import type { IBuildingCard } from 'shared/types/buildingCard';

/** Адрес как `GeoPresenterDetail.address` монолита: только адресообразующие элементы */
export function getAddressText(card: IBuildingCard): string {
  return card.address
    .filter(item => item.isFormingAddress && item.shortName)
    .map(item => item.shortName)
    .join(', ');
}
